import styles from "./styles.module.scss";

type EmptyProps = {
  text?: string;
};
export function Empty(props: EmptyProps) {
  return (
    <div className={styles.empty}>
      <div className={styles.emptyContent}></div>
      <div className={styles.emptyText}>{props.text || "暂时没有更多数据"}</div>
    </div>
  );
}
